/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/
import TextFieldGroup from "../common_input/TextFieldGroup";

/*REDUX*/
import { loginUser, loginUserKAI } from "../../App/actions/authActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";

/*CONST*/

const Login = ({
  auth,
  errors: props_errors,
  loginUser,
  loginUserKAI,
  isNav,
}) => {
  const [name, set_name] = useState("");
  const [password, set_password] = useState("");
  const [errors, set_errors] = useState({});
  const [show_password, set_show_password] = useState(false);

  // Replaces getDerivedStateFromProps
  useEffect(() => {
    if (props_errors) {
      set_errors(props_errors);
    }
  }, [props_errors]);

  const toggleShowPassword = () => {
    set_show_password(!show_password);
  };

  const onChange = (e) => {
    const { id, value } = e.target;
    if (id === "name") set_name(value);
    if (id === "password") set_password(value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const domain_w_port = window.location.host;
    const pathname = window.location.pathname;
    const is_login_kai =
      pathname === "/login_qa"
        ? false
        : domain_list[domain_w_port]?.is_login_kai;

    if (is_login_kai) {
      const userData = {
        username: name,
        password: password,
      };
      loginUserKAI(userData);
    } else {
      const nav_value = isNav ? isNav : null;
      const userData = {
        name: name,
        password: password,
        isNav: nav_value,
      };
      loginUser(userData);
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === "Enter") {
      onSubmit(e);
    }
  };

  const language = localStorage?.language ? localStorage?.language : "ina";
  const domain_w_port = window.location.host;
  const pathname = window.location.pathname;
  const is_login_kai =
    pathname === "/login_qa" ? false : domain_list[domain_w_port]?.is_login_kai;

  const { loading } = auth;

  let iconButton = (
    <button
      style={{ height: "59px", fontSize: "0.88em" }}
      className="marginTop_20 rounded_5 bg_black text_white w_full"
      onClick={(e) => onSubmit(e)}
      data-mapid="clickLogin"
    >
      {dict["Sign in"][language]}
    </button>
  );
  if (loading) {
    iconButton = (
      <button
        style={{ height: "59px", fontSize: "0.88em" }}
        className="button_disable rounded_5 bg_grey text_white w_full h_50"
      >
        {dict["Sign in..."][language]}
      </button>
    );
  }

  let content = (
    <div //noValidate onSubmit={this.onSubmit}
    >
      <TextFieldGroup
        Title={is_login_kai ? "NIPP" : "E-mail / Username"}
        placeholder={
          dict[is_login_kai ? "Enter your NIPP" : "Enter your email/username"][
            language
          ]
        }
        name="name"
        id="name"
        value={name}
        onChange={onChange}
        error={errors.data?.name}
        className="input_border"
        handleKeyDown={handleKeyDown}
      />
      <br />
      <TextFieldGroup
        type={show_password ? "text" : "password"}
        isPassword={true}
        Title={dict["Password"][language]}
        placeholder={dict["Enter Your Password"][language]}
        name="password"
        id="password"
        value={password}
        onChange={onChange}
        toggleShowPassword={toggleShowPassword}
        pattern="[0-9a-zA-Z]{8,}"
        error={errors.data?.password}
        className="input_border"
        handleKeyDown={handleKeyDown}
      />
      <div className="バランス flex justify_end marginTop_20 marginBottom_20">
        <Link to="/forget-password">
          <p data-mapid="clickForgotPassword">
            {dict["Forgot Password"][language]}?
          </p>
        </Link>
      </div>
      {iconButton}
    </div>
  );

  return <main>{content}</main>;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  loginUser,
  loginUserKAI,
})(Login);
